module.exports = __webpack_public_path__ + "img/jiu2.ecb329c0.png";